import type * as Types from '../../types';

import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/client';
export type GetMoodleModulsQueryVariables = Types.Exact<{
  where?: Types.Maybe<Types.MoodleModulFilterInput>;
  take?: Types.Maybe<Types.Scalars['Int']>;
  skip?: Types.Maybe<Types.Scalars['Int']>;
  order?: Types.Maybe<Array<Types.MoodleModulSortInput> | Types.MoodleModulSortInput>;
}>;


export type GetMoodleModulsQuery = { moodleModuls: Array<{ __typename?: 'MoodleModul', id: number, modulId?: Types.Maybe<number>, moodleModulInternId?: Types.Maybe<number>, modulVerantwortlicherId?: Types.Maybe<number>, lehrenderId?: Types.Maybe<number>, zeitraumId?: Types.Maybe<number>, modulVerantwortlicher?: Types.Maybe<{ __typename?: 'StammdatenMa', id: number, vorname: string, nachname: string }>, lehrender?: Types.Maybe<{ __typename?: 'StammdatenMa', id: number, vorname: string, nachname: string }>, modul?: Types.Maybe<{ __typename?: 'Modul', id: number, modulName: string, modulNameIntern?: Types.Maybe<string>, ectspunkte?: Types.Maybe<number>, studiengangTyp?: Types.Maybe<{ __typename?: 'StudiengangTyp', id: number, studiengangTypName: string, studiengangTypKuerzel?: Types.Maybe<string> }>, stammdatenMaha?: Types.Maybe<{ __typename?: 'StammdatenMa', id: number, vorname: string, nachname: string }> }>, zeitraum?: Types.Maybe<{ __typename?: 'Zeitraum', id: number, zeitraumName: string, zeitraumVon: string, zeitraumBis: string }> }> };


export const GetMoodleModulsDocument = gql`
    query getMoodleModuls($where: MoodleModulFilterInput, $take: Int, $skip: Int, $order: [MoodleModulSortInput!]) {
  moodleModuls(where: $where, take: $take, skip: $skip, order: $order) {
    id
    modulId
    moodleModulInternId
    modulVerantwortlicherId
    lehrenderId
    modulVerantwortlicher {
      id
      vorname
      nachname
    }
    lehrender {
      id
      vorname
      nachname
    }
    modul {
      id
      modulName
      modulNameIntern
      ectspunkte
      studiengangTyp {
        id
        studiengangTypName
        studiengangTypKuerzel
      }
      stammdatenMaha {
        id
        vorname
        nachname
      }
    }
    zeitraumId
    zeitraum {
      id
      zeitraumName
      zeitraumVon
      zeitraumBis
    }
  }
}
    `;

/**
 * __useGetMoodleModulsQuery__
 *
 * To run a query within a React component, call `useGetMoodleModulsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoodleModulsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoodleModulsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetMoodleModulsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMoodleModulsQuery, GetMoodleModulsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMoodleModulsQuery, GetMoodleModulsQueryVariables>(GetMoodleModulsDocument, baseOptions);
      }
export function useGetMoodleModulsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMoodleModulsQuery, GetMoodleModulsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMoodleModulsQuery, GetMoodleModulsQueryVariables>(GetMoodleModulsDocument, baseOptions);
        }
export type GetMoodleModulsQueryHookResult = ReturnType<typeof useGetMoodleModulsQuery>;
export type GetMoodleModulsLazyQueryHookResult = ReturnType<typeof useGetMoodleModulsLazyQuery>;
export type GetMoodleModulsQueryResult = ApolloReactCommon.QueryResult<GetMoodleModulsQuery, GetMoodleModulsQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
